import { usePermissions } from "./usePermissions";

/**
 * Frontend mirror of the lifting category card requests (`App\Http\Requests\V2\LiftingCategoryCheck`,
 * dijkgraaf-gateway-api): the lifting category assistant has no company, so managing it is admin-only.
 * A UX convenience only — the backend is what actually enforces it.
 */
export function useLiftingCategoryPermissions() {
  const permissions = usePermissions();

  return {
    loading: permissions.loading,
    canManageLiftingCategoryAssistant: permissions.isAdmin,
  };
}
